/* eslint-disable @typescript-eslint/no-explicit-any */
import BlogCard from '@/components/BlogList/BlogCard'
import { LoadingIndicator } from '@/components/LoadingIndicator'
import PostBreadcrumb from '@/components/PostBreadcrumb'
import { BannerType } from '@/constants'
import { useBlogHook } from '@/hooks/useBlogHook'
import { Meta } from '@/layouts/Meta'
import { Main } from '@/templates/Main'
import type { BannerList, Post, PostResponse } from '@/types'
import { getTranslate, setContext } from '@/utils/api-interceptors'
import {
  getBannerSSR,
  getBottomMenu,
  getConfigSSR,
  getHeaderMenu,
  getKeyword,
  getPostCategory,
  getPostsByCategory,
  getSaleRegion,
} from '@/utils/endpoint'
import { getCookies } from 'cookies-next'
import { type GetServerSideProps, type GetServerSidePropsContext } from 'next'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

type ListBlogProps = {
  postData: PostResponse
  postCategory: Post[]
  checkActiveCate: Post
  banner: BannerList[]
}

const ListBlog = ({
  postData,
  postCategory,
  checkActiveCate,
  banner,
}: ListBlogProps) => {
  const router = useRouter()
  const {
    setLoading,
    loading,
    currentPage,
    setCurrentPage,
    getPosts,
    posts,
    setPosts,
    totalPages,
  } = useBlogHook(postData)
  const fetchMorePost = () => {
    setLoading(true)
    setCurrentPage(currentPage + 1)
    getPosts(
      {
        limit: 9,
        currentPage: currentPage + 1,
        catSlugs: checkActiveCate?.slugs?.value?.vi,
      },
      {
        onSuccess: res => {
          if (posts) {
            setPosts(posts.concat(res.data.data))
          }
          setLoading(false)
        },
        onError: () => {
          setLoading(false)
        },
      }
    )
  }
  const bannerBlog = useMemo(() => {
    return banner.filter(banner => {
      return banner.type === BannerType.BLOG && banner.status === 1
    })
  }, [banner])

  return (
    <Main
      meta={
        <Meta
          title={'Thông tin hữu ích'}
          description={'Thông tin hữu ích'}
          noFollow={false}
          noIndex={false}
          canonical={process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath}
          mobileAlternate={{
            media: 'only screen and (max-width:991px))',
            href:
              process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE + router.asPath ||
              process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE ||
              '',
          }}
        />
      }
    >
      <PostBreadcrumb
        breadcrumbs={postCategory}
        title={getTranslate(checkActiveCate?.name)}
        activeId={checkActiveCate?._id}
        banner={bannerBlog}
      />
      {posts && posts.length > 0 ? (
        <section className='postDetail relative mt-5 min-h-[500px] pb-10'>
          <div className='grid grid-cols-3 gap-4'>
            {posts?.map((e: Post, index) => (
              <BlogCard key={index} post={e} type={6} />
            ))}
          </div>
          {loading && <LoadingIndicator />}
          {totalPages && totalPages > currentPage && (
            <button
              onClick={fetchMorePost}
              className='mx-auto mb-10 mt-5 flex h-10 w-[200px] items-center justify-center rounded-lg border border-primary text-primary'
            >
              Xem tất cả
            </button>
          )}
        </section>
      ) : (
        <section className='postDetail relative mt-5 min-h-[500px] pb-10'></section>
      )}
    </Main>
  )
}

export default ListBlog

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { query, req, res } = context
  const { token, language, messages } = await setContext(
    getCookies({ req, res }),
    {
      language: context.locale,
    }
  )

  const [
    bottomMenu,
    globalHeaderMenu,
    keywords,
    postData,
    postCategory,
    banner,
    regions,
    systemConfig,
  ] = await Promise.all([
    getBottomMenu(),
    getHeaderMenu(),
    getKeyword(),
    getPostsByCategory(query?.slug as string),
    getPostCategory(),
    getBannerSSR(),
    getSaleRegion(),
    getConfigSSR(),
  ])
  const checkActiveCate = postCategory?.find(
    e => e?.slugs?.value?.vi == query?.slug
  )

  return {
    props: {
      bottomMenu,
      globalHeaderMenu,
      keywords,
      postData,
      postCategory,
      checkActiveCate,
      banner,
      language,
      messages,
      regions,
      systemConfig,
      token: token || null,
    },
  }
}
